// extracted by mini-css-extract-plugin
module.exports = {"cms-faq-wrapper":"Faq__cms-faq-wrapper___Z7OLX"};